import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';


import { Price } from '@app/shared/models/price';
import { ProductCategory, QuantityRequirements } from './package-product.fragment';

@Injectable({
  providedIn: 'root'
})
export class GetStorefrontCatalogGQL extends Query<GetStorefrontCatalogGQLResponse, GetStorefrontCatalogGQLVariables> {
  document = gql`
  query getStorefrontCatalog($storefrontId: ID, $onlyActive: Boolean, $onlyWithActiveSubscriptions: Boolean) {
    storefronts(storefrontIds: [$storefrontId]) {
      catalog {
        products(onlyActive:$onlyActive, onlyWithActiveSubscriptions: $onlyWithActiveSubscriptions) {
          productId
          sku
          name
          msrp {
            amount
          }
          price {
            amount
          }
          categories {
            name
            position
          }
          description
          isActive
          subscriptionMonths
          quantityRequirements {
            min
            max
            increment
          }
        }
      }
    }
  }
  `;
}

interface GetStorefrontCatalogGQLResponse {
  storefronts: { catalog: StorefrontCatalog }[];
}

interface GetStorefrontCatalogGQLVariables {
  storefrontId: string;
  onlyActive: boolean;
  onlyWithActiveSubscriptions: boolean;
}

export interface StorefrontCatalog {
  products: CatalogProduct[];
}

export interface CatalogProduct {
  productId: string;
  sku: string;
  name: string;
  msrp: Price;
  price: Price;
  categories: ProductCategory[];
  description: string;
  isActive: boolean;
  subscriptionMonths: number;
  quantityRequirements: QuantityRequirements;
}
